import {Pipe, PipeTransform} from '@angular/core';

export const ExtractPrimaryId = (value: string): string => {
  const parts = value.split('/');
  if (parts.length === 1) {
    return parts[0];
  }
  parts.pop();
  return parts.join('/');
};

@Pipe({
  name: 'primaryId'
})
export class PrimaryIdPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return ExtractPrimaryId(value);
  }

}
